import React from "react";

function Itenaries() {
  return (
    <div className="mt-12 mb-5">
      <h1 className="font-semibold text-xl tracking-tighter capitalize">
        Trip itineraries
      </h1>
      <p className="text-xs tracking-tighter text-neutralText">Your trip itineraries are placed here</p>
    </div>
  );
}

export default Itenaries;
